
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("afBrg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::28e818db41afcf6fce742cecb9d4361e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $776858abadb4b212$var$_react = $776858abadb4b212$var$_interopRequireDefault((parcelRequire("42omo")));

var $776858abadb4b212$var$_baseNew = $776858abadb4b212$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $776858abadb4b212$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeAudioBriefing".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Audio Briefings, a new feature launching within Confluence to help people develop an expanded awareness on a topic by generating AI-powered podcasts about their work.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $776858abadb4b212$var$AiGenerativeAudioBriefingIcon = (props)=>/*#__PURE__*/ $776858abadb4b212$var$_react.default.createElement($776858abadb4b212$var$_baseNew.default, Object.assign({
        name: "AiGenerativeAudioBriefingIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0c.97 0 1.88.2 2.72.55l-.24.09c-.52.19-.93.56-1.19 1.02A5.5 5.5 0 0 0 2.5 7v.71A2.5 2.5 0 0 1 6 10v3.08A1.92 1.92 0 0 1 4.08 15 3.08 3.08 0 0 1 1 12V7a7 7 0 0 1 7-7M3.5 9a1 1 0 0 0-1 1v1.92c0 .87.71 1.58 1.58 1.58.23 0 .42-.19.42-.42V10a1 1 0 0 0-1-1m11.46-2.78Q15 6.6 15 7v5a3.08 3.08 0 0 1-3.08 3A1.92 1.92 0 0 1 10 13.08V10a2.5 2.5 0 0 1 3.5-2.29v-.73a2.25 2.25 0 0 0 1.46-.77M12.5 9a1 1 0 0 0-1 1v3.08c0 .23.19.42.42.42.87 0 1.58-.71 1.58-1.58V10a1 1 0 0 0-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M13.365.009a.75.75 0 0 1 .541.378l.05.106.334.92a.5.5 0 0 0 .298.297l.919.335a.75.75 0 0 1 0 1.41l-.92.335a.5.5 0 0 0-.297.298l-.335.919a.75.75 0 0 1-1.41 0l-.335-.92a.5.5 0 0 0-.298-.297l-.919-.335a.75.75 0 0 1-.484-.589L10.5 2.75l.009-.116a.75.75 0 0 1 .484-.59l.92-.334a.5.5 0 0 0 .297-.298l.335-.919A.75.75 0 0 1 13.249 0z"/>`
    }, props));
$776858abadb4b212$var$AiGenerativeAudioBriefingIcon.displayName = 'AiGenerativeAudioBriefingIcon';
var $776858abadb4b212$var$_default = module.exports.default = $776858abadb4b212$var$AiGenerativeAudioBriefingIcon;

});

parcelRegister("aVEh3", function(module, exports) {
/**
 * TODO: Once briefings V1 is removed, we can rename this file to `useAudio` so that it is more feature-agnostic.
 *
 * The reason we are not renaming it now is to reduce friction with the existing Briefings V1 feature
 * and thus just adding the activeFeature state and actions here.
 *
 * Once Briefings V1 is removed, we can update the name of this hook and also add a discriminated union
 * for all audio types and export feature specific hooks that converge onto the new `useAudio` hook.
 *
 * Part of reason we are not building on the new hook now is because some of the existing subcomponents
 * such as ToneSelector are used by both Briefings V1 and V2, so introduceing a new hook would mean that
 * these subcomponents would need to be either duplicated or call two state hooks.
 */ 
var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $1P1Tu = parcelRequire("1P1Tu");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $f7B1p = parcelRequire("f7B1p");

const $a8c440a68b7f1d7a$export$b74ed40f1201d575 = '/gateway/api/v1/audio/summary';
const $a8c440a68b7f1d7a$export$6cb88531520814ca = '/gateway/api/v1/audio/narration';
const $a8c440a68b7f1d7a$export$6cea0b5571f5494d = '/gateway/api/v1/audio/briefing';
const $a8c440a68b7f1d7a$export$dae6df74caa4c21f = '/gateway/api/v1/audio/briefing/popular';
const $a8c440a68b7f1d7a$export$d12c91205ffb6498 = async ({ pageAri: pageAri, locale: locale, activationId: activationId })=>{
    const response = await (0, $f7B1p.cfetch)($a8c440a68b7f1d7a$export$b74ed40f1201d575, {
        method: 'POST',
        body: JSON.stringify({
            resource_ari: pageAri,
            locale: locale
        }),
        headers: {
            'Content-Type': 'application/json',
            'ATL-ActivationId': activationId
        }
    });
    if (!response.body) throw new Error('Response body is null');
    return response.body;
};
const $a8c440a68b7f1d7a$export$98358e5f5de55fe1 = async ({ activeContentAri: activeContentAri, locale: locale, activationId: activationId })=>{
    const response = await (0, $f7B1p.cfetch)($a8c440a68b7f1d7a$export$6cb88531520814ca, {
        method: 'POST',
        body: JSON.stringify({
            resource_ari: activeContentAri,
            locale: locale,
            transcriber_model: 'TEXT_ONLY'
        }),
        headers: {
            'Content-Type': 'application/json',
            'ATL-ActivationId': activationId
        }
    });
    if (!response.body) throw new Error('Response body is null');
    return response.body;
};
const $a8c440a68b7f1d7a$export$376975d31f493b5f = async ({ activeContentAri: activeContentAri, additionalResources: additionalResources, locale: locale, activationId: activationId, customization: customization })=>{
    const additionalResourcesBody = additionalResources.map((resource)=>({
            resource_ari: resource.ari,
            activation_id: activationId
        }));
    const response = await (0, $f7B1p.cfetch)($a8c440a68b7f1d7a$export$6cea0b5571f5494d, {
        method: 'POST',
        body: JSON.stringify({
            resources: [
                {
                    resource_ari: activeContentAri,
                    activation_id: activationId
                },
                ...additionalResourcesBody
            ],
            locale: locale,
            user_instruction: customization
        }),
        headers: {
            'Content-Type': 'application/json',
            'ATL-ActivationId': activationId
        }
    });
    if (!response.body) throw new Error('Response body is null');
    return response.body;
};
const $a8c440a68b7f1d7a$export$fad8b3947c9aadf = async (activationId, locale, customization)=>{
    const response = await (0, $f7B1p.cfetch)($a8c440a68b7f1d7a$export$dae6df74caa4c21f, {
        method: 'POST',
        body: JSON.stringify({
            locale: locale,
            user_instruction: customization
        }),
        headers: {
            'Content-Type': 'application/json',
            'ATL-ActivationId': activationId
        }
    });
    if (!response.body) throw new Error('Response body is null');
    return response.body;
};



var $3KEcv = parcelRequire("3KEcv");


var $f6lSf = parcelRequire("f6lSf");


var $7LiF4 = parcelRequire("7LiF4");


var $iqGoX = parcelRequire("iqGoX");


var $hBkCm = parcelRequire("hBkCm");




const $e183ec8972c1b3cf$export$5f39437091559ad1 = async (error)=>{
    if (error instanceof (0, $hBkCm.BadStatusError)) try {
        const response = error.response.clone();
        const errorData = await response.json();
        if (errorData.error?.includes('minimum context requirements')) return (0, $iqGoX.AudioBriefingError).CONTENT_TOO_SHORT;
    } catch (parseError) {
    // If error doesn't have response, or parsing fails, treat as general-error
    }
    return (0, $iqGoX.AudioBriefingError).GENERAL_ERROR;
};


const $383af3bced28b02d$var$DEFAULT_CUSTOMIZATION = {
    tone: (0, $3KEcv.CustomTone).PROFESSIONAL,
    length: (0, $3KEcv.CustomLength).SHORT
};
const $383af3bced28b02d$var$DEFAULT_PLAYBACK_SPEED = 1;
const $383af3bced28b02d$var$safeParseJson = (json)=>{
    try {
        return JSON.parse(json);
    } catch (e) {
        return $383af3bced28b02d$var$DEFAULT_CUSTOMIZATION;
    }
};
const $383af3bced28b02d$var$_performFeatureFetch = async (feature, req)=>{
    switch(feature){
        case (0, $7LiF4.AudioFeature).BRIEFING:
            {
                const stream = await (0, $a8c440a68b7f1d7a$export$376975d31f493b5f)(req);
                return {
                    stream: stream,
                    patch: {
                        lastGeneratedBriefingConfig: {
                            additionalResources: req.additionalResources,
                            customization: req.customization
                        }
                    }
                };
            }
        case (0, $7LiF4.AudioFeature).NARRATION:
            {
                const stream = await (0, $a8c440a68b7f1d7a$export$98358e5f5de55fe1)(req);
                return {
                    stream: stream,
                    patch: {}
                };
            }
        default:
            throw new Error('Unsupported audio feature');
    }
};
const $383af3bced28b02d$var$initialAudioBriefingState = {
    activeContent: undefined,
    activeFeature: undefined,
    customization: $383af3bced28b02d$var$DEFAULT_CUSTOMIZATION,
    additionalResources: [],
    cloudId: '',
    activationId: '',
    locale: 'en-US',
    isLoading: false,
    isPlaying: false,
    isClosed: false,
    isEnded: false,
    hasEndBeenReached: false,
    hasFetched: false,
    lastGeneratedBriefingConfig: undefined,
    playbackSpeed: $383af3bced28b02d$var$DEFAULT_PLAYBACK_SPEED,
    stream: undefined,
    error: undefined,
    errorType: undefined,
    streamEnded: false,
    requestKey: 0
};
const $383af3bced28b02d$export$924be06a1d1cfd91 = {
    initialize: (initialState)=>async ({ setState: setState })=>{
            const storedCustomization = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).AI_AUDIO_BRIEFING_CUSTOMIZATION);
            const parsedCustomization = storedCustomization ? $383af3bced28b02d$var$safeParseJson(storedCustomization) : $383af3bced28b02d$var$DEFAULT_CUSTOMIZATION;
            const emptyAudioBriefingState = {
                stream: undefined,
                streamEnded: false,
                activeContent: undefined,
                activeFeature: undefined,
                customization: parsedCustomization,
                additionalResources: [],
                locale: 'en-US',
                cloudId: '',
                activationId: '',
                isLoading: false,
                isPlaying: false,
                isClosed: false,
                isEnded: false,
                hasEndBeenReached: false,
                hasFetched: false,
                error: undefined,
                errorType: undefined,
                playbackSpeed: Number((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).AI_AUDIO_PLAYBACK_SPEED)) || $383af3bced28b02d$var$DEFAULT_PLAYBACK_SPEED,
                requestKey: 0
            };
            setState(Object.assign(emptyAudioBriefingState, initialState));
        },
    reset: ()=>({ setState: setState })=>{
            setState($383af3bced28b02d$var$initialAudioBriefingState);
        },
    _invalidateInFlightRequests: ()=>({ getState: getState, setState: setState })=>{
            const { requestKey: requestKey } = getState();
            setState({
                requestKey: (requestKey ?? 0) + 1
            });
        },
    addAdditionalResource: (newAdditionalResource)=>({ getState: getState, setState: setState })=>{
            const { additionalResources: additionalResources } = getState();
            setState({
                additionalResources: [
                    ...additionalResources,
                    newAdditionalResource
                ]
            });
        },
    removeAdditionalResource: (ariToRemove)=>({ getState: getState, setState: setState })=>{
            const { additionalResources: additionalResources } = getState();
            const newResourcesList = additionalResources.filter((resource)=>resource.ari !== ariToRemove);
            setState({
                additionalResources: newResourcesList
            });
        },
    fetchBriefing: ()=>async ({ dispatch: dispatch })=>{
            dispatch($383af3bced28b02d$export$924be06a1d1cfd91.fetchAudio({
                feature: (0, $7LiF4.AudioFeature).BRIEFING
            }));
        },
    fetchNarration: ()=>async ({ dispatch: dispatch })=>{
            dispatch($383af3bced28b02d$export$924be06a1d1cfd91.fetchAudio({
                feature: (0, $7LiF4.AudioFeature).NARRATION
            }));
        },
    fetchAudio: ({ feature: feature })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
            dispatch($383af3bced28b02d$export$924be06a1d1cfd91.onLoadStart(feature));
            const { requestKey: capturedRequestKey, activeContent: activeContent, additionalResources: additionalResources, cloudId: cloudId, activationId: activationId, locale: locale, customization: customization } = getState();
            if (!activeContent) {
                dispatch($383af3bced28b02d$export$924be06a1d1cfd91.setContentError(new Error('Briefing container needs to be initialized')));
                return;
            }
            const activeContentAri = (0, $f6lSf.getConfluenceContentAri)(cloudId, activeContent.id, activeContent.contentType);
            if (!activeContentAri) {
                dispatch($383af3bced28b02d$export$924be06a1d1cfd91.setContentError(new Error('Content ARI failed to generate')));
                return;
            }
            const isStale = ()=>getState().requestKey !== capturedRequestKey;
            try {
                const apiRequest = {
                    activeContentAri: activeContentAri,
                    additionalResources: additionalResources,
                    activationId: activationId,
                    locale: locale,
                    customization: customization
                };
                const { stream: stream, patch: patch } = await $383af3bced28b02d$var$_performFeatureFetch(feature, apiRequest);
                if (isStale() || getState().isClosed) return;
                setState({
                    isPlaying: false,
                    isEnded: false,
                    hasEndBeenReached: false,
                    stream: stream,
                    ...patch
                });
            } catch (e) {
                if (isStale()) return;
                const errorType = await (0, $e183ec8972c1b3cf$export$5f39437091559ad1)(e);
                setState({
                    error: e,
                    errorType: errorType,
                    stream: undefined
                });
            } finally{
                if (!isStale()) dispatch($383af3bced28b02d$export$924be06a1d1cfd91.onLoadEnd());
            }
        },
    onLoadStart: (feature)=>({ setState: setState, dispatch: dispatch })=>{
            dispatch($383af3bced28b02d$export$924be06a1d1cfd91._invalidateInFlightRequests());
            setState({
                activeFeature: feature,
                isLoading: true,
                hasFetched: true,
                error: undefined,
                errorType: undefined,
                streamEnded: false
            });
        },
    onLoadEnd: ()=>({ setState: setState })=>{
            setState({
                isLoading: false
            });
        },
    pauseContent: ()=>({ setState: setState })=>{
            setState({
                isPlaying: false
            });
        },
    resumeContent: ()=>({ setState: setState, getState: getState })=>{
            const { stream: stream } = getState();
            if (!stream) throw new Error('Must fetch before playing');
            setState({
                isPlaying: true,
                isEnded: false
            });
        },
    setContentPlaybackSpeed: (speed)=>({ setState: setState })=>{
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).AI_AUDIO_PLAYBACK_SPEED, speed);
            setState({
                playbackSpeed: speed
            });
        },
    stopContent: ()=>async ({ dispatch: dispatch, setState: setState })=>{
            dispatch($383af3bced28b02d$export$924be06a1d1cfd91.reset());
            setState({
                isClosed: true
            });
        },
    endContent: ()=>({ setState: setState })=>{
            setState({
                isEnded: true,
                hasEndBeenReached: true,
                isPlaying: false
            });
        },
    setContentError: (error)=>({ setState: setState })=>{
            setState({
                error: error,
                errorType: (0, $iqGoX.AudioBriefingError).GENERAL_ERROR
            });
        },
    setStreamEnded: (streamEnded)=>({ setState: setState })=>{
            setState({
                streamEnded: streamEnded
            });
        },
    setCustomization: (newCustomization)=>({ setState: setState, getState: getState })=>{
            const { customization: customization } = getState();
            const updatedCustomization = {
                ...customization,
                ...newCustomization
            };
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).AI_AUDIO_BRIEFING_CUSTOMIZATION, JSON.stringify({
                tone: updatedCustomization.tone,
                length: updatedCustomization.length
            }));
            setState({
                customization: updatedCustomization
            });
        }
};
const $383af3bced28b02d$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: {
        activeContent: undefined,
        customization: $383af3bced28b02d$var$DEFAULT_CUSTOMIZATION,
        additionalResources: [],
        cloudId: '',
        activationId: '',
        locale: 'en-US',
        isLoading: false,
        isPlaying: false,
        isClosed: false,
        isEnded: false,
        hasEndBeenReached: false,
        hasFetched: false,
        playbackSpeed: 1,
        error: undefined,
        errorType: undefined,
        streamEnded: false,
        requestKey: 0
    },
    actions: $383af3bced28b02d$export$924be06a1d1cfd91,
    name: 'listenerState'
});
const $383af3bced28b02d$export$ff3c0e7d5b0100a7 = (0, $FOT9i.createContainer)($383af3bced28b02d$export$390f32400eaf98c9, {
    onInit: ()=>async ({ dispatch: dispatch }, { initialAudioBriefingState: initialAudioPlaybackState })=>{
            dispatch($383af3bced28b02d$export$924be06a1d1cfd91.initialize(initialAudioPlaybackState));
        }
});
const $383af3bced28b02d$export$5f4418f41c33b771 = (0, $9zUhf.createHook)($383af3bced28b02d$export$390f32400eaf98c9);
const $383af3bced28b02d$export$722396384dacf938 = (0, $9zUhf.createActionsHook)($383af3bced28b02d$export$390f32400eaf98c9);
module.exports["useAudioBriefing"] = $383af3bced28b02d$export$5f4418f41c33b771;

});

parcelRegister("3KEcv", function(module, exports) {
const $6babaf5010ad9ae0$export$22914fe597403470 = {
    PLAYFUL: 'playful',
    PROFESSIONAL: 'professional',
    CONVERSATIONAL: 'conversational',
    SURPRISE: 'surprise'
};
const $6babaf5010ad9ae0$export$91791b32a6f45c02 = {
    SHORT: 'short',
    MEDIUM: 'medium',
    LONG: 'long'
};
module.exports["CustomTone"] = $6babaf5010ad9ae0$export$22914fe597403470;
module.exports["CustomLength"] = $6babaf5010ad9ae0$export$91791b32a6f45c02;

});

parcelRegister("f6lSf", function(module, exports) {

var $eB56w = parcelRequire("eB56w");

var $a2xFu = parcelRequire("a2xFu");

var $a5Dk4 = parcelRequire("a5Dk4");

const $f16877b6875ebf37$export$6a2f2c83863e9bfe = (siteId, contentId, contentType)=>{
    try {
        switch(contentType){
            case 'page':
                return (0, $a2xFu.ConfluencePageAri).create({
                    siteId: siteId,
                    pageId: contentId
                });
            case 'blogpost':
                return (0, $eB56w.ConfluenceBlogpostAri).create({
                    siteId: siteId,
                    blogpostId: contentId
                });
            case 'whiteboard':
                return (0, $a5Dk4.ConfluenceWhiteboardAri).create({
                    siteId: siteId,
                    whiteboardId: contentId
                });
        }
    } catch  {
        return undefined;
    }
    return undefined;
};
module.exports["getConfluenceContentAri"] = $f16877b6875ebf37$export$6a2f2c83863e9bfe;

});

parcelRegister("7LiF4", function(module, exports) {
const $06aae44591cf448a$export$ae7d97a50b8bcedb = {
    BRIEFING: 'briefing',
    NARRATION: 'narration'
};
module.exports["AudioFeature"] = $06aae44591cf448a$export$ae7d97a50b8bcedb;

});

parcelRegister("iqGoX", function(module, exports) {
const $9970821b1217563d$export$9d929f8d0507419c = {
    CONTENT_TOO_SHORT: 'content-too-short',
    GENERAL_ERROR: 'general-error'
};
module.exports["AudioBriefingError"] = $9970821b1217563d$export$9d929f8d0507419c;

});

parcelRegister("52Sgp", function(module, exports) {

var $iXzFq = parcelRequire("iXzFq");

const $f8dae92e82bbcfd5$export$aab6a07214727b65 = (audioContent1, audioContent2)=>{
    return audioContent1.id === audioContent2.id && audioContent1.spaceKey === audioContent2.spaceKey && audioContent1.contentType === audioContent2.contentType && audioContent1.sourceType === audioContent2.sourceType;
};
const $f8dae92e82bbcfd5$export$f60f45b8c8af98e4 = (activeAudioContent)=>{
    return !!activeAudioContent.id && !!activeAudioContent.spaceKey && !!activeAudioContent.contentType;
};


const $fc8507f52b4402cb$var$getOrigin = ()=>{
    return window.location.hostname === 'localhost' ? `https://${window.__backendOriginHost}` : window.location.origin;
};
const $fc8507f52b4402cb$export$701669137e89de62 = (activeContent)=>{
    if ((0, $f8dae92e82bbcfd5$export$f60f45b8c8af98e4)(activeContent)) {
        const contentPath = (0, $iXzFq.getUrlForContentType)({
            contentType: activeContent.contentType,
            contentId: activeContent.id,
            // @ts-ignore Checked by above conditional
            spaceKey: activeContent.spaceKey
        });
        return `${$fc8507f52b4402cb$var$getOrigin()}${contentPath}`;
    }
    return null;
};
module.exports["getContentUrl"] = $fc8507f52b4402cb$export$701669137e89de62;

});

parcelRegister("4wsPv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lbhE8 = parcelRequire("lbhE8");


var $aU1TP = parcelRequire("aU1TP");

const $441d910c6d0db13d$export$9ea8ebe6968f73b1 = ()=>{
    const state = (0, $lbhE8.useAtom)((0, $aU1TP.audioPlayerStreamingStore));
    const updateAudioPlayerStreamingStore = (0, $42omo.useCallback)((action)=>{
        (0, $aU1TP.setAudioPlayerStreamingStore)(action);
    }, []);
    return {
        state: state,
        updateAudioPlayerStreamingStore: updateAudioPlayerStreamingStore
    };
};
module.exports["useAudioPlayerStreamingStore"] = $441d910c6d0db13d$export$9ea8ebe6968f73b1;

});

parcelRegister("aU1TP", function(module, exports) {

var $9TRAA = parcelRequire("9TRAA");

var $ae4e7949267550f2$export$eb3237121301a5e5 = /*#__PURE__*/ function(AudioStreamingState) {
    AudioStreamingState["UNINITIALIZED"] = "uninitialized";
    AudioStreamingState["LOADING"] = "loading";
    AudioStreamingState["ERROR"] = "error";
    AudioStreamingState["STREAM_STARTED"] = "stream_started";
    AudioStreamingState["STREAM_DISPOSED"] = "stream_disposed";
    return AudioStreamingState;
}({});
const $ae4e7949267550f2$export$a0ed58682f50d27c = (0, $9TRAA.e)({
    state: "uninitialized"
});
const $ae4e7949267550f2$export$218145c33c4aee2e = (action)=>{
    switch(action.type){
        case "uninitialized":
            $ae4e7949267550f2$export$a0ed58682f50d27c.set({
                state: "uninitialized"
            });
            break;
        case "loading":
            $ae4e7949267550f2$export$a0ed58682f50d27c.set({
                state: "loading"
            });
            break;
        case "error":
            $ae4e7949267550f2$export$a0ed58682f50d27c.set({
                state: "error",
                error: action.error
            });
            break;
        case "stream_started":
            $ae4e7949267550f2$export$a0ed58682f50d27c.set({
                state: "stream_started",
                response: action.response
            });
            break;
        case "stream_disposed":
            $ae4e7949267550f2$export$a0ed58682f50d27c.set({
                state: "stream_disposed"
            });
            break;
    }
};
module.exports["AudioStreamingState"] = $ae4e7949267550f2$export$eb3237121301a5e5;
module.exports["audioPlayerStreamingStore"] = $ae4e7949267550f2$export$a0ed58682f50d27c;
module.exports["setAudioPlayerStreamingStore"] = $ae4e7949267550f2$export$218145c33c4aee2e;

});


//# sourceMappingURL=ObjectSidebarControl.13ae695b.js.map
